import React from 'react';
import classNames from 'classnames';

import './StageFilesEmptyState.styles.scss';

type StageFilesEmptyStateProps = {
  className?: string;
  title: string;
  description: string;
};

const StageFilesEmptyState: React.FC<StageFilesEmptyStateProps> = (props) => {
  const { className, title, description, children } = props;

  const classes = classNames('stage-files-empty-state', className);

  return (
    <div className={classes}>
      <p className="stage-files-empty-state__title">{title}</p>
      <p className="stage-files-empty-state__description">{description}</p>
      {children}
    </div>
  );
};

export default StageFilesEmptyState;
